import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import LoadingState from '@components/LoadingState';
import MainLayout from '@layouts/MainLayout';

import { routes } from './routeConfig';

/**
 * Top-level router. Every page is lazy-loaded -- the matched route component
 * is wrapped in a `Suspense` boundary with a centralized fallback so route
 * transitions feel consistent and we don't duplicate Suspense boilerplate per
 * page.
 */
const AppRoutes = () => (
  <Routes>
    <Route element={<MainLayout />}>
      {routes.map(({ path, component: Component, fallback }) => (
        <Route
          key={path}
          path={path}
          element={
            <Suspense fallback={fallback ?? <LoadingState label="Loading..." />}>
              <Component />
            </Suspense>
          }
        />
      ))}
    </Route>
  </Routes>
);

export default AppRoutes;
